import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';

import { processLinkGroup } from './processLinkGroup';
import type { LinkGroup } from './types';

export function useGetInvolvedLinks(): LinkGroup | null {
	const { translate } = useI18n();
	const sourceLocation = 'source_location=footer_link';
	const locale = useLocale();

	return processLinkGroup({
		title: translate('corgi.components.footer.section.get_involved'),
		links: [
			{
				href: `/start-a-petition?${sourceLocation}`,
				title: translate('corgi.components.footer.links.sap'),
			},
			{
				href: `/topic?${sourceLocation}`,
				title: translate('corgi.components.footer.links.browse_topic'),
			},
			...(locale === 'en-US'
				? [
						{
							href: `/local?${sourceLocation}`,
							title: translate('corgi.components.footer.links.browse_location'),
						},
					]
				: []),
			{
				href: `/search?${sourceLocation}`,
				title: translate('corgi.components.footer.links.search_petitions'),
			},
		],
	});
}
